import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import { IInfoModal } from "./IInfoModal";
import { useEffect, useState } from "react";


const css = `
.MuiTypography-root{
    font-size: 14px;
}
`;
const style = {
    position: "absolute" as "absolute",
    top: "40%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "var(--input-bg-color)",
    boxShadow: 24,
};
const InfoModal = ({ content, onConfirm, openModal }: IInfoModal) => {
    const [open, setOpen] = useState<boolean>(openModal);
    useEffect(() => {
        setOpen(openModal);
    }, [openModal]);

    return (
        <Modal open={open}
            onClose={() => setOpen(false)}
            className="border300"
            aria-labelledby="keep-mounted-modal-title"
            aria-describedby="keep-mounted-modal-description"

        >
            <Box className="ModalCmp" sx={style} style={{ borderRadius: "5px", padding: "3vh", direction: 'rtl' }}>
                <div style={{ marginBottom: '3vh', marginTop: '3vh' }}>
                    <Typography className="text-center !font-bold text-[var(--primary-text-color)] anjomanRegular" style={{ fontSize: '14px' }}>
                        {content}
                    </Typography>
                </div>
                <Button
                    sx={{ background: "var(--button-color)", color: "var(--semilar-color)" }}
                    onClick={() => onConfirm()}
                    fullWidth
                >
                    متوجه شدم
                </Button>
            </Box>

        </Modal>
    )
}

export default InfoModal